import { Link } from "react-router-dom";
import { Rating } from "react-simple-star-rating";
import { H4, P } from "../../../../../AbstractElements";
import { useAppSelector } from "../../../../../ReduxToolkit/Hooks";
import { ProductDetailsProp } from "../../../../../Types/EcommerceType";

export const ProductDetails:React.FC<ProductDetailsProp> = ({ item }) => {
  const { symbol } = useAppSelector((state) => state.product);
  return (
    <div className="product-details">
      <Rating fillColor="#ffa800" initialValue={Math.random() * 5} size={17} />
      <Link to={`${process.env.PUBLIC_URL}/applications/ecommerce/product_page`}>
        <H4>{item.name}</H4>
      </Link>
      <P>{item.note}</P>
      <div className="product-price">
        {symbol}
        {item.price}
        <del className="f-w-700">
          {symbol}
          {item.discountPrice}
        </del>
      </div>
    </div>
  );
};
